import { SEARCH_BANNER_VARIANT } from '../../data-model/constants';
import { VariantA } from './VariantA';
import { VariantB } from './VariantB';
import { VariantC } from './VariantC';

/**
 * Which layout each Config Service value renders.
 *
 * This is the only place in `src` that knows more than one variant exists. Variants never import
 * each other and nothing in `blocks/` imports a variant, so retiring one cannot affect the others.
 *
 * To retire a variant once the test concludes:
 *   1. delete its entry below and its file in this directory;
 *   2. prune the blocks it was the last consumer of — `grep -rl <BlockName> src/` lists them, and
 *      anything left with no consumer can go.
 *
 * `disabled` deliberately has no entry, and neither does any unrecognised value.
 */
const LAYOUTS = {
  [SEARCH_BANNER_VARIANT.VARIANT_A]: VariantA,
  [SEARCH_BANNER_VARIANT.VARIANT_B]: VariantB,
  [SEARCH_BANNER_VARIANT.VARIANT_C]: VariantC,
};

/**
 * The layout for `variant`, or `undefined` when there is none — which the banner treats as off, so
 * the switch fails closed by construction rather than by a separate list that could drift from this
 * one.
 *
 * The own-property check keeps an inherited key such as `constructor` from passing as a layout.
 *
 * @param {string} [variant] - Raw Config Service value.
 * @returns {(React.ComponentType|undefined)}
 */
export const layoutForVariant = (variant) => (
  Object.prototype.hasOwnProperty.call(LAYOUTS, variant) ? LAYOUTS[variant] : undefined
);
